/**
 * Turns a hex or rgb(a) color into the "r, g, b" channels Ionic expects in its `-rgb` variables.
 * Returns null when the color format is not supported.
 */
export const toRgbChannels = (color: string): string | null => {
  const value = color.trim();

  const hex = /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.exec(value)?.[1];
  if (hex) {
    const digits = hex.length === 3 ? hex.replace(/./g, digit => digit + digit) : hex.slice(0, 6);
    return [0, 2, 4].map(start => parseInt(digits.slice(start, start + 2), 16)).join(", ");
  }

  const rgb = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/i.exec(value);
  return rgb ? rgb.slice(1, 4).join(", ") : null;
};
